class UserClass{
    // id
    username=''
    password=''
    role='admin'
    isActive=true
    description=''
    stringName=''
    location=''
    game=''

}
 
export default UserClass;